import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { CODES } from '../../../../utils/responseCodes';
import { simpleAlerts } from '../../../../utils/alerts2';
import SpinnerLoader from '../../../components/Spinner/Loader';
import MainInput from '../../../components/general/MainInput';
import ReportService from '../../../../services/report';
import { getDateOL02 } from '../../../../utils/function';
import { Tabs, Tab } from '@mui/material';
import GroupingSede from '../../../components/GroupingSede';

const ReportApp = ({ userToken }) => {
  const [openModalLoader, setOpenModalLoader] = useState(false);
  const [titleModalLoader, setTitleModalLoader] = useState(null);

  const [dateInit, setDateInit] = useState(getDateOL02());
  const [dateEnd, setDateEnd] = useState(getDateOL02('', 'short', 7));
  const [type, setType] = useState(1);

  //* inicio variables para el agrupamiento */
  const [infoCompany, setInfoCompany] = useState(null);
  const [infoClient, setInfoClient] = useState(null);
  const [infoUnit, setInfoUnit] = useState(null);
  const [infoCampus, setInfoCampus] = useState(null);
  //* fin variables para el agrupamiento */

  const [activeTab, setActiveTab] = useState('sede');

  const containerStyles = {
    position: 'relative',
    width: '90%',
    maxWidth: '900px',
    backgroundColor: '#FFFFFF',
    borderRadius: '20px',
    margin: '0 auto',
    marginTop: '25px',
    border: 'solid 1px #FF9CA6',
  };

  const formStyles = {
    // position: 'absolute',
    margin: '20px 20px 10px 20px',
    zIndex: 9999,
  };


  const generateSede = async () => {
    if (!infoCampus?.value) {
      simpleAlerts('Seleccione una Sede', 'warning');
    } else {
      try {
        setTitleModalLoader('Generando Reporte de Sede...');
        setOpenModalLoader(true);

        const result = await ReportService.generateSede(dateInit, dateEnd, infoCampus?.value, type);
        if (result.status === CODES.SUCCESS_200) {
          const blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'TAREO_SEDE_' + infoCampus?.desSede + "_" + dateInit + '_' + dateEnd + '.xlsx';
          link.click();
          URL.revokeObjectURL(url);
          //getPeople();
          setOpenModalLoader(false);
        } else {
          setOpenModalLoader(false);
          setTitleModalLoader(null);
        }
        return []
      } catch (error) {
        console.log(`Error en generateSede: ${error}`);
      }
    }
  }

  const generateReportMarks = async () => {
    if (!infoCampus?.value) {
      simpleAlerts('Seleccione una Sede', 'warning');
      return;
    }

    if (!dateInit || dateInit === '' || !dateEnd || dateEnd === '') {
      simpleAlerts('Debe seleciconar ambas fechas inicio y fin', 'warning');
      return;
    }
    try {
      setTitleModalLoader('Generando Reporte de Marcas...');
      setOpenModalLoader(true);
      let result = "";
      if (activeTab === 'sede') {
        result = await ReportService.exportReportMarksBySedeExcel(dateInit, dateEnd, infoCampus?.value, infoCampus?.desSede);
      }
      if (result.status === CODES.SUCCESS_200) {
        const blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'MARCAS_' + infoCampus?.desSede + "_" + dateInit + '_' + dateEnd + '.xlsx';
        link.click();
        URL.revokeObjectURL(url);
        //getPeople();
        setOpenModalLoader(false);
      } else {
        setOpenModalLoader(false);
        setTitleModalLoader(null);
      }
      return []
    } catch (error) {
      console.log(`Error en generateReportMarks: ${error}`);
    }
  }

  return (
    <Box sx={{ flexGrow: 1 }} style={containerStyles}>
      <Tabs
        centered
        value={activeTab}
        onChange={(event, newValue) => setActiveTab(newValue)}
      >
        <Tab value="sede" label="Por Sede" />
      </Tabs>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        style={formStyles}
      >
        <Grid item xs={12} sm={8} md={12}>
          <Grid container justifyContent="center" alignItems="center">

            <Grid item xs={12} sm={6} md={10}>
              <GroupingSede
                openModalLoader={openModalLoader} setOpenModalLoader={setOpenModalLoader}
                infoCompany={infoCompany} setInfoCompany={setInfoCompany}
                infoClient={infoClient} setInfoClient={setInfoClient}
                infoUnit={infoUnit} setInfoUnit={setInfoUnit}
                infoCampus={infoCampus} setInfoCampus={setInfoCampus}
              />
            </Grid>

          </Grid>
          <Grid container p={1} justifyContent="center" alignItems="center" spacing={1.2}>
            <Grid item xs={12} sm={6} md={5}>
              <MainInput
                title={"Fecha Inicio"}
                placeholder={"Ingrese Fecha Inicio"}
                type={"date"}
                value={dateInit}
                onChange={(e) => setDateInit(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={5}>
              <MainInput
                title={"Fecha Fin"}
                placeholder={"Ingrese Fecha Fin"}
                type={"date"}
                value={dateEnd}
                onChange={(e) => setDateEnd(e.target.value)}
                propsInput={{ min: dateInit }}
              />
            </Grid>
          </Grid>

          <Grid container p={1} justifyContent="center" alignItems="center">
            {/*<Grid item xs={12} sm={6} md={4} style={{ marginLeft: "2rem" }}>
              <span
                className="badge text-bg-secondary"
                style={{ marginBottom: "10px" }}
              >
                Estado Trabajador:
              </span>
              <div>
                <input
                  type="radio"
                  id={"byActive"}
                  name="typeStatus"
                  value={1}
                  checked={type === 1}
                  onChange={(e) => setType(Number(e.target.value))}
                />
                <label
                  htmlFor={"byActive"}
                  style={{ padding: "0.2rem 0.5rem" }}
                >
                  Activo
                </label>
                <br />
              </div>
              <div>
                <input
                  type="radio"
                  id={"byCesado"}
                  name="typeStatus"
                  value={2}
                  checked={type === 2}
                  onChange={(e) => setType(Number(e.target.value))}
                />
                <label
                  htmlFor={"byCesado"}
                  style={{ padding: "0.2rem 0.5rem" }}
                >
                  Cesado
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  id={"byAll"}
                  name="typeStatus"
                  value={0}
                  checked={type === 0}
                  onChange={(e) => setType(Number(e.target.value))}
                />
                <label htmlFor={"byAll"} style={{ padding: "0.2rem 0.5rem" }}>
                  Ambos
                </label>
              </div>
            </Grid>
          */}
            <Grid item xs={12} sm={6} md={12} style={{ display: "flex", justifyContent: "center" }}>
              <button
                type="button"
                className="btn btn-dark"
                onClick={generateReportMarks}
              >
                REPORTE MARCAS
              </button>
            </Grid>
          </Grid>
          <SpinnerLoader open={openModalLoader} title={titleModalLoader} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReportApp;